// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-card-heading{margin-bottom:4px;font-weight:700;font-style:normal}.category-card-worker-container{overflow:hidden;width:360px;border-bottom:1px solid}.category-card-worker-ul{padding-bottom:16px;padding-left:0;list-style-type:none}.category-card-worker-li-item{font-weight:400;font-style:normal}.category-card-worker-contact-details>a{display:block;overflow:hidden;font-style:italic;font-size:.9em;text-overflow:ellipsis}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
